'use strict';

import { Card, Col, Row, Table, Tree } from 'antd';
import React from 'react';
import { copy, ObjFactory, PrmFactory } from 'rt-sd-common';
import { convertModuleByGuid } from "rt-sd-comp";
import { createFormInfo, onExpand, onSelect, renderTreeNodes } from './common';


class ParamMngDef extends React.Component {
    constructor(props) {
        super(props);

        let guid = this.props.guid;

        let objFct = new ObjFactory(guid);

        let treeData = [];
        let prm = PrmFactory.getPrm(guid);
        if (prm.cldSet) {
            treeData = prm.cldSet;
        }

        this.state = {
            forms: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
            columns: {}, //客群定义显示form，一个属性一个form,{key:form,key2:form2}
            formsValue: {},
            showCtls: {}, //存储所有显示控件
            objFct: this.props.objFct || objFct,
            loading: false,
            checkedAtts: {},
            checkedAtts_table: {},//新加表格勾选节点
            treeData: treeData,
            checkedKeys: [],
            expandedKeys: [],
            data: this.props.data || []
        };
    }

    convertData = (e) => {
        //校验 组装数据
        let errors = [];
        let errorMsg;
        for (var tmpKey in this.state.showCtls) {
            let tmpCtl = this.state.showCtls[tmpKey];
            let ctlDisplay = this.state.formsValue[tmpCtl.props.moduleDesc.cRef]["ctl2Display"];
            if (ctlDisplay != 'none') {
                errorMsg = tmpCtl.validate();
                if (errorMsg) {
                    errors.push(errorMsg);
                }
            }
        }

        if (errors.length > 0) {
            //组装数据
            this.setState({ loading: false })
            // alert('校验失败');//这里不用提示，组件自身提示
            return null;
        }

        let data = [];
        for (var tmpKey in this.state.checkedAtts) {
            let tmpSaveRecord = this.state.objFct.get(tmpKey + "_tmp");
            let matchType = tmpSaveRecord.match_type;
            let value = tmpSaveRecord.value1;
            if (matchType == "Between" || matchType == "NotBetween") {
                value += "," + tmpSaveRecord.value2;
            }
            let obj = {
                tagId: tmpSaveRecord.id,
                tagName: tmpSaveRecord.te,
                matchType: matchType,
                valueType: tmpSaveRecord.valueType || "01",
                featureValue: value,
                tagCode: tmpSaveRecord.c
            };
            data.push(obj);
        }

        // 处理表方式展示的数据
        let tableData = [];
        for (let tmpKey in this.state.checkedAtts_table) {
            let tmpData = this.state.checkedAtts_table[tmpKey];
            if (tableData.indexOf(tmpData) < 0) tableData.push(tmpData);
        }
        let tableDataCopy = copy(tableData, true);
        this.deleteOverKeys(tableDataCopy, this.state.checkedAtts_table);

        data.push(...tableDataCopy);

        let objFct = this.props.objFct;
        let dataInst = this.props.dataInst;
        if (dataInst && objFct) {
            objFct.set(dataInst, data);
        }

        return data;

    }

    deleteOverKeys = (items = [], keys = {}) => {
        items.forEach(item => {
            if (item.ds) {
                // 继续向下
                this.deleteOverKeys(item.ds, keys);
            } else {
                for (const key in item) {
                    if (!keys[key]) delete item[key];
                }
            }
        });
    }

    refreshData = (data, loading) => {

        if (loading) {
            this.state.hide = tool.popMessage("加载中，请稍后", "loading", null, 0);
        }

        if (!data) return;

        //重置
        this.state.forms = {};
        this.state.formsValue = {};
        if (!this.props.allData) this.state.checkedAtts = {};
        this.state.showCtls = {};
        if (!this.props.allData) this.state.checkedAtts_table = {};

        let checkedKeys = []; let expandedKeys = [];
        let treeData = this.state.treeData;
        data.forEach(item => {
            if (item.rel && item.sc) {
                // 表格展示数据
                let gr = this.findGroup(treeData, item);
                if (gr) {
                    // gr.data = item;
                    if (gr.data) merge(gr.data, item);
                    else gr.data = item;
                    let keys = this.getColumnKeys(item.ds);
                    for (const rec of gr.cldSet) {
                        let c = rec.c;
                        if (c && keys.indexOf(c) > -1) {
                            let id = rec.id;
                            this.state.checkedAtts_table[id] = item;
                            this.state.columns[id] = {
                                // style: { minWidth: 100 },
                                width: rec.width || undefined,
                                title: rec.te, dataIndex: rec.c, key: rec.c,
                                render: (text, record, index) => {
                                    let ctl = convertModuleByGuid(this, { ...rec, isLbl: true }, record, this.state.objFct, "N");
                                    delete ctl.ref;
                                    return ctl;
                                }
                            }
                            checkedKeys.push(rec._key);
                            if (expandedKeys.indexOf(gr._key) < 0) expandedKeys.push(gr._key);
                        }
                    }
                }
            } else {
                // form展示数据
                item.tagId = item.tagId || item.featureTagId;
                for (const gr of treeData) {
                    if (!gr.cldSet) continue;
                    for (const rec of gr.cldSet) {
                        if (item.tagId == rec.id) {
                            checkedKeys.push(rec._key);
                            if (expandedKeys.indexOf(gr._key) == -1) {
                                expandedKeys.push(gr._key);
                            }
                            let matchType = item.matchType;
                            let ctl2Display = "none";
                            let value = item.featureValue;
                            let value1 = value, value2;
                            if (matchType == "Between" || matchType == "NotBetween") {
                                ctl2Display = undefined;
                                let values = value.split(",");
                                value1 = values[0];
                                value2 = values[1];
                            }
                            this.state.formsValue[rec.c] = { ...rec, match_type: matchType, ctl2Display: ctl2Display, value1: value1, value2: value2 };
                            createFormInfo(this, rec, matchType, value1, value2);
                            break;
                        }
                    }
                }
            }
        });
        this.setState({ checkedKeys });
        this.setState({ expandedKeys });

    }

    findGroup = (treeData = [], relGroup = {}) => {
        let treeGroup = {};
        if (treeData.some(node => {
            if (node.sc === relGroup.sc) {
                treeGroup = node;
                return true;
            } else if (node.cldSet && node.cldSet.length > 0) {
                treeGroup = this.findGroup(node.cldSet, relGroup);
                return treeGroup;
            }
        })) {
            return treeGroup;
        };
    }
    getColumnKeys = (items = []) => {
        let keys = [];
        items.forEach(item => {
            if (item.ds && item.ds.length > 0) {
                let sonKeys = this.getColumnKeys(item.ds) || [];
                sonKeys.forEach(key => keys.indexOf(key) < 0 && keys.push(key));
            } else {
                for (const key in item) {
                    if (keys.indexOf(key) < 0) keys.push(key);
                }
            }
        });
        return keys;
    }

    handleChange(attc, match_type, dataRef, value) {

        if (value == "Between" || value == "NotBetween") {
            this.state.formsValue[attc]["ctl2Display"] = undefined;
        } else {
            this.state.formsValue[attc]["ctl2Display"] = 'none';
        }
        this.state.formsValue[attc][match_type] = value;
        createFormInfo(this, dataRef, value); //重新创建
        this.setState({ loading: false })
    }



    onCheck = (checkedKeys, e) => {
        this.state.checkedKeys = checkedKeys;

        let checkFlag = e.checked;
        let node = e.node;
        let dataRef = node.props.dataRef;
        let parentDataRef = node.props.parentDataRef;

        if (dataRef.nodeType == "group") {
            let cldSet = dataRef.cldSet || [];
            cldSet.forEach(cld => {
                this.checkOne(cld, checkFlag, dataRef);
            });
        } else {
            this.checkOne(dataRef, checkFlag, parentDataRef);
        }

        this.setState({ loading: false });
    }

    checkOne = (one, checkFlag, parentDataRef) => {
        if (one.nodeType === "group") {
            let cldSet = one.cldSet || [];
            cldSet.forEach(cld => {
                this.checkOne(cld, checkFlag, one);
            });
            return;
        }
        let c = one.c;
        if (!c) return;

        if (parentDataRef && parentDataRef.isList) {
            // 表格形式
            let id = one.id;
            if (checkFlag) {
                if (!one.desId) one.desId = "EP_EO_UI_3101";//添加默认值-文本框

                // 记录勾选了哪些节点
                this.state.checkedAtts_table[id] = Object.assign(parentDataRef.data, {
                    te: parentDataRef.te,
                    sc: parentDataRef.sc,
                    ann: parentDataRef.ann
                });
                // 隐藏标签
                one.isLbl = true;

                this.state.columns[id] = {
                    width: one.width || undefined,
                    title: one.te, dataIndex: one.c, key: one.c,
                    render: (text, record, index) => {
                        let ctl = convertModuleByGuid(this, one, record, this.state.objFct, "N");
                        delete ctl.ref;
                        return ctl;
                    }
                };
            } else {
                delete this.state.columns[id];
                // delete this.state.formsValue[c];
                delete this.state.checkedAtts_table[id];
            }
        } else {
            // form形式
            let match_type = one.match_type || one.defaultMatchType || "EqualTo";
            let ctl2Display = "none";
            if (match_type == "Between" || match_type == "NotBetween") {
                ctl2Display = undefined;
            }

            if (checkFlag) {
                this.state.formsValue[c] = { ...one, match_type: match_type, ctl2Display: ctl2Display };
                createFormInfo(this, one, match_type);
            } else {
                delete this.state.forms[c];
                delete this.state.formsValue[c];
                delete this.state.checkedAtts[c];
                delete this.state.showCtls[c + "value1"];
                delete this.state.showCtls[c + "value2"];
            }
        }
    }

    refModalFunction(ctl) {
        if (!ctl) {
            return;
        }
        let { moduleDesc, objFct } = ctl.props;
        this.state.showCtls[moduleDesc.cRef + moduleDesc.c] = ctl;
    }

    renderCardNodes = (data = [], forms = [], columns = []) => {
        return data.map((item) => {
            if (item.cldSet) {
                return (
                    <Card size="small" title={item.te} style={{ display: this.checkChecked(item.cldSet) ? undefined : "none", margin: "10px" }}>
                        {item.isList ? this.renderTable(item, columns) : this.renderCardNodes(item.cldSet, forms, columns)}
                    </Card>
                );
            }
            // return forms[item.c];
            return this.props.noTree ? (<Col span={12}>{forms[item.c]}</Col>) : forms[item.c];
        });
    }

    checkChecked = (items = []) => items.some(item => this.state.forms[item.c] || this.state.columns[item.id] || this.checkChecked(item.cldSet))

    renderTable = (item = {}, columns = {}) => {
        let cldSet = item.cldSet || [];
        let rlData = item.data;
        if (!rlData) rlData = item.data = { rel: "or", ds: [] };
        let dataSource = rlData.ds;
        let tbColumns = [{
            dataIndex: 'rel',
            render: (text, record, index) => dataSource.indexOf(record) === 0 ? null : "或"
        }, {
            dataIndex: 'content',
            render: (text, record, index) => `内部关系数量：${(record.ds || []).length}`
        }, {
            title: <a style={{ whiteSpace: "nowrap" }}
                onClick={() => dataSource.push({ rel: "and", ds: [] }) && this.setState({})}
            > {`+添加${dataSource.length > 0 ? `"或"` : ""}条件组`}</a >,
            width: 50,
            align: "right",
            render: (text, record, index) => <a onClick={() => dataSource.splice(dataSource.indexOf(record), 1) && this.setState({})}>删除条件组</a>
        }];
        let nestedColumns = [{ dataIndex: 'rel', width: 20 }];
        cldSet.forEach(cld => {
            if (columns[cld.id]) {
                nestedColumns.push(columns[cld.id]);
            }
        });
        nestedColumns.push({ width: 50, align: "right" });
        const expandedRowRender = rowRecord => {
            // let nested_rlData = rowRecord.ds;
            // if (!nested_rlData) nested_rlData = rowRecord.ds = { rel: "and", ds: [] };
            let nestedDataSource = rowRecord.ds;
            nestedColumns[0].render = (text, record, index) => nestedDataSource.indexOf(record) === 0 ? null : "且"
            nestedColumns[nestedColumns.length - 1].title = <a style={{ whiteSpace: "nowrap" }}
                onClick={() => nestedDataSource.push({}) && this.setState({})}
            >{`+添加${nestedDataSource.length > 0 ? `"且"` : ""}条件`}</a>;
            nestedColumns[nestedColumns.length - 1].render = (text, record, index) => <a onClick={() => nestedDataSource.splice(nestedDataSource.indexOf(record), 1) && this.setState({})}>删除条件</a>;
            return <Table
                size="small"
                columns={nestedColumns}
                dataSource={nestedDataSource}
                pagination={false}
            />
        };
        return (
            <Table
                size="small"
                columns={tbColumns}
                expandedRowRender={expandedRowRender}
                dataSource={dataSource}
                pagination={false}
            />
        );
    }

    componentDidMount() {
        if (this.props.data && this.props.data.length > 0) {
            this.refreshData(this.props.data);
        } else if (this.props.allData) {
            let treeData = this.state.treeData || [];
            treeData.forEach(d => this.onCheck([], { checked: true, node: { props: { dataRef: d } } }));
        }
        // this.refreshData(this.state.data);
    }

    componentDidUpdate() {
        let hide = this.state.hide;
        if (hide) hide();
    }

    render() {

        var showList = this.renderCardNodes(this.state.treeData, this.state.forms, this.state.columns);

        return (
            <div style={{ height: '100%', width: '100%', overflow: "auto" }}>
                {this.props.noTree
                    ? <div style={{ height: '100%', overflow: "auto" }}>{showList}</div>
                    : <Row style={{ height: '100%', width: '100%' }}>
                        <Col style={{ overflow: 'auto' }} span={5}>
                            <Tree
                                checkable
                                onExpand={onExpand.bind(this)}
                                expandedKeys={this.state.expandedKeys}
                                // autoExpandParent={this.state.autoExpandParent}
                                onCheck={this.onCheck}
                                checkedKeys={this.state.checkedKeys}
                                onSelect={onSelect.bind(this)}
                            // selectedKeys={this.state.selectedKeys}
                            >
                                {renderTreeNodes(this.state.treeData)}
                            </Tree>
                        </Col>
                        <Col style={{ height: '100%' }} span={19}>
                            {showList}
                        </Col>
                    </Row>
                }
            </div >

        )
    }

}

export default ParamMngDef;

/**
 * 属性合并
 * @param {object} target 目标对象
 * @param {object} source 源对象
 */
function merge(target, source) {
    // 目标和源相同，直接返回
    if (target === source) return target;
    // 分情况处理
    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
        for (let key in source) {
            if (target[key] === source[key]) continue;//相同，跳过
            if (!target[key]) target[key] = source[key];//target属性不存在，直接赋值
            else target[key] = merge(target[key], source[key]);//target属性存在，合并
        }
    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
        for (let i = 0; i < source.length; i++) {
            if (target[i] === source[i]) continue;//相同，跳过
            if (!target[i]) target.push(source[i]);//target元素不存在，直接添加
            else target[i] = merge(target[i], source[i]);//target元素存在，合并
        }
    } else {//其他情况，直接赋值
        target = source;
    }
    // 返回target
    return target;

}


// WEBPACK FOOTER //
// ./apps/pages/paramMng/ParamMngDef.js